import { PropsWithChildren } from 'react';
import { StyledCardContainer } from './style';

interface IProps {
  overflow?: 'hidden' | 'visible' | 'auto' | 'initial';
  padding?: string;
}

const StyledCard = ({
  children,
  padding,
  overflow = 'hidden',
}: PropsWithChildren<IProps>) => {
  return (
    <StyledCardContainer
      className="styled-card"
      overflow={overflow}
      padding={padding}
    >
      {children}
    </StyledCardContainer>
  );
};

export default StyledCard;